<style lang="less" scoped>
    .query-title-div{
        width:150px !important;
    }
</style>

<template>
    <div class="list-container">
        <div class="list-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="list-content-div">
            <div class="list-header-title-div">公司信息列表</div>
            <div class="page-action-btns flex margin-tb-10">
                <button class="common-bg-button" @click="listAddFun()">新 增</button>
                <button class="common-bg-button" @click="listEditFun()">编 辑</button>
                <button class="common-bg-button" @click="listEditFun()">查看</button>
                <button class="common-bg-button" @click="toHandelRecord()">操作日志</button>
                <div class="flex-1"></div>
                <el-input placeholder="请输入公司ID/名称/邮政编码/详细地址" size="small" style="width:240px;margin-right:15px"></el-input>
                <button class="common-bg-button" @click="getListData(pagination,true)">搜 索</button>
                <button class="common-bg-button"          
                 @click="() => {
                    showMultiQuerys = !showMultiQuerys;
                    }">高级筛选</button>
            </div>
            <!-- 高级筛选 -->
            <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
                <div class="margin-bottom-16">
                <el-row :gutter="20">
                    <el-col :span="6">
                    <p class="margin-bottom-5 font-14">国内/海外：</p>
                    <el-select
                        v-model="queryInfo.spareTypeCategory"
                        size="small"
                        filterable
                        class="full-width"
                        @change="getDealer(queryInfo.spareTypeCategory)"
                        clearable
                        placeholder="请选择"
                    >
                        <el-option
                        v-for="item in typeList"
                        :key="item.configVal"
                        :label="item.configName"
                        :value="item.configVal"
                        ></el-option>
                    </el-select>
                    </el-col>
                    <el-col :span="6">
                    <p class="margin-bottom-5 font-14">状态：</p>
                    <el-select
                        v-model="queryInfo.spareTypeCategory"
                        size="small"
                        filterable
                        class="full-width"
                        @change="getDealer(queryInfo.spareTypeCategory)"
                        clearable
                        placeholder="请选择"
                    >
                        <el-option
                        v-for="item in typeList"
                        :key="item.configVal"
                        :label="item.configName"
                        :value="item.configVal"
                        ></el-option>
                    </el-select>
                    </el-col>
                    <el-col :span="6">
                    <p class="margin-bottom-5 font-14">国家：</p>
                    <el-select
                        v-model="queryInfo.spareTypeCategory"
                        size="small"
                        filterable
                        class="full-width"
                        @change="getDealer(queryInfo.spareTypeCategory)"
                        clearable
                        placeholder="请选择"
                    >
                        <el-option
                        v-for="item in typeList"
                        :key="item.configVal"
                        :label="item.configName"
                        :value="item.configVal"
                        ></el-option>
                    </el-select>
                    </el-col>
                    <el-col :span="6">
                    <p class="margin-bottom-5 font-14">州省：</p>
                    <el-select
                        v-model="queryInfo.spareTypeCategory"
                        size="small"
                        filterable
                        class="full-width"
                        @change="getDealer(queryInfo.spareTypeCategory)"
                        clearable
                        placeholder="请选择"
                    >
                        <el-option
                        v-for="item in typeList"
                        :key="item.configVal"
                        :label="item.configName"
                        :value="item.configVal"
                        ></el-option>
                    </el-select>
                    </el-col>
                    <el-col :span="6">
                    <p class="margin-bottom-5 font-14">城市：</p>
                    <el-select
                        v-model="queryInfo.spareTypeCategory"
                        size="small"
                        filterable
                        class="full-width"
                        @change="getDealer(queryInfo.spareTypeCategory)"
                        clearable
                        placeholder="请选择"
                    >
                        <el-option
                        v-for="item in typeList"
                        :key="item.configVal"
                        :label="item.configName"
                        :value="item.configVal"
                        ></el-option>
                    </el-select>
                    </el-col>
                    <el-col :span="6">
                    <p class="margin-bottom-5 font-14">区县：</p>
                    <el-select
                        v-model="queryInfo.spareTypeCategory"
                        size="small"
                        filterable
                        class="full-width"
                        @change="getDealer(queryInfo.spareTypeCategory)"
                        clearable
                        placeholder="请选择"
                    >
                        <el-option
                        v-for="item in typeList"
                        :key="item.configVal"
                        :label="item.configName"
                        :value="item.configVal"
                        ></el-option>
                    </el-select>
                    </el-col>
                </el-row>
                </div>
            </div>
            <!-- 表格 -->
            <div class="list-table">
                <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData" :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="(sels)=>{selections=sels}"></ZD-table>
            </div>
            <!-- 分页 -->
            <div class="list-pagination">
                <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
            </div>
            <!-- 密码重置 -->
            <el-dialog title="密码重置" width="520px" :visible.sync="pwdResetObj.showDialog">
                <el-form :model="pwdResetObj.formInfo" ref="pwdResetRef" :rules="pwdResetObj.rules">
                    <el-form-item label="用户手机号" prop="userPhone">
                        {{userPhone}}
                    </el-form-item>
                    <el-form-item label="用户名" prop="userName">
                        {{userName}}
                    </el-form-item>
                    <el-form-item label="用户密码" prop="restPassWord">
                        <el-input v-model="pwdResetObj.formInfo.restPassWord" type="password" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="checknewPassWord">
                        <el-input v-model="pwdResetObj.formInfo.checknewPassWord" type="password" size="small"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="pwdResetObj.showDialog = false" size="small">取 消</el-button>
                    <el-button type="primary" @click="submitPwdFrom('pwdResetRef')" size="small">确 定</el-button>
                </div>
            </el-dialog>
            <!-- 操作日志 -->
            <el-dialog title="操作日志" width="60%" :visible.sync="handelRecordObj.showDialog">
                <el-table
                    class="el-table"
                    :data="handelRecordObj.tableData"
                    border
                    max-height="200px"
                    style="width: 100%;margin:20px auto"
                    :cell-style="{ 'text-align': 'center' }"
                    :header-cell-style="{background:'#FAFAFA',color:'#8F9BB3',fontSize: '14px',textAlign:'center', border: '1px solid #F0F0F0'}"
                    >
                    <el-table-column
                        prop="deviceName"
                        label="操作人">
                    </el-table-column>
                    <el-table-column
                        prop="statusChangeTime"
                        label="更改时间">
                    </el-table-column>
                    <el-table-column
                        prop="content"
                        label="更改类型">
                    </el-table-column>
                    <el-table-column
                        prop="statusChangeTime"
                        label="原始数据">
                    </el-table-column>
                    <el-table-column
                        prop="content"
                        label="更改数据">
                    </el-table-column>
                </el-table>
                <div class="list-pagination">
                    <ZD-pagination :pagination="handelRecordObj.pagination" v-on:pageUpdate="getListData"></ZD-pagination>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '' || value === undefined) {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.pwdResetObj.formInfo.restPassWord) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            
            return {
                pageConfig: pageConfig, // 页面配置
                tableData: [], // 表格数据
                selections: [], // 表格选项
                showMultiQuerys:false,
                pagination: pageConfig.pagination,
                queryInfo: {}, //页码
                typeList:[],
                operates: {
					width: 220,
					fixed: "right",
					list: [
						
					]
                }, // 列操作按钮
                statueArr:[],  //角色状态下拉框
                pwdResetObj: {
                    showDialog: false,
                    formInfo: {},
                    rules: {
                        restPassWord: [{
                            required: true,
                            message: '请输入新密码',
                            trigger: 'blur'
                        }],
                        checknewPassWord: [{
                            required: true,
                            validator: validatePass,
                            trigger: 'blur'
                        }],
                    },
                },
                userPhone: '',//用户手机号码
                userName: '',//用户姓名
                handelRecordObj:{
                    showDialog: false,
                    tableData: [],  
                    pagination: {
                        current: 1,
                        total: 0,
                        pageSize: 10,
                        pageSizes: [10, 20, 50, 100],
                    },
                }
            }
        },
        methods: {
            //执行表格数据函数 角色状态下拉框
            init() {
                this.getListData(this.pagination,true);
                this.getConfig();
            },
            // 获取表格数据
            getListData(pagination, reload = false) {
                let _ = this;
                _.$U.showLoading(_);
                _.queryInfo.pageNum = pagination.current - 1;
                if (reload) {
                    this.pagination.current = 1;
                    _.queryInfo.pageNum = 0;
                }
                _.queryInfo.pageSize = pagination.pageSize;
                _.queryInfo.corpNo = _.$store.state.corpNo;
                _.$H.get(_, _.$A.user.list, _.queryInfo).then(res => {
                    _.tableData = res.data.data.content || [];
                    _.pagination.total = res.data.data.totalElements || 0;
                    _.$U.hideLoading(_);
                })
            },
            //角色状态下拉框
            getConfig(){
                let _ = this;
                _.$H.post(_,_.$A.config.list,{configType:"192"}).then(res => {
                    _.statueArr = res.data.data;
                })
            },
            // 页面新增方法
            listAddFun() {
                this.$S.listAddFun(this, pageConfig.tableEditObj);
            },
            // 页面编辑方法
            listEditFun() {
                this.$S.tableEditFun(this, this.selections, pageConfig.tableEditObj);
            },
            //重置按钮
            reset(){
                this.pagination.current = 1;
                delete this.queryInfo.status;
                delete this.queryInfo.searchKey;
                this.getListData(this.pagination);
            },
            //密码修改
            toResetPwd() {

                this.userPhone = '';
                this.userName = '';
                this.pwdResetObj.formInfo = {};
                if(this.selections.length < 1){
                    this.$U.error('请选择需要操作的对象')
                }else if(this.selections.length > 1){
                    this.$U.error('只能选择一个操作的对象')
                }else{
                    this.pwdResetObj.showDialog = true;
                    this.userPhone = this.selections[0].userPhone;
                    this.userName = this.selections[0].userName;
                    this.pwdResetObj.formInfo.userId = this.selections[0].userId;
                }
            },
            toHandelRecord(){
                this.handelRecordObj.showDialog = true;
                return 
                if(this.selections.length < 1){
                    this.$U.error('请选择需要操作的对象')
                }else if(this.selections.length > 1){
                    this.$U.error('只能选择一个操作的对象')
                }else{
                    this.handelRecordObj.showDialog = true;
                }
            },
            //密码提交
            submitPwdFrom(formName) {
                    let _ = this;
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            var obj = {
                                restPassWord: _.pwdResetObj.formInfo.restPassWord,
                                userId: _.pwdResetObj.formInfo.userId
                            }
                            _.$H.post(_, _.$A.user.userPwdReset, obj).then(res => {
                                _.$U.success('修改成功')
                                _.pwdResetObj.showDialog = false;
                            })
                        }
                    });
            },
        },
        mounted() {
            // this.init();
        }
    }
</script>